<div class="user-management-header">
    <h2>Liste des utilisateurs</h2>
    <div class="search-add">
        <div class="search-bar-container">
            <frg-search-input (search)="onSearch($event)"></frg-search-input>
        </div>
        <button routerLink="/administration/user-creation">
            <div class="svg-user-add"></div>
        </button>
    </div>
</div>
<div class="user-management-body">
    <div class="user-management-table">
        <!-- <div class="title">
            Liste des utilisateurs trouvés
        </div> -->
        <div class="table">
            <frg-table [keysColumn]="userColumnTable" [keysBody]="profilList" tableButton1="assets/icons/trash.svg"
                tableButton2="assets/icons/edit.svg" (onClick1)="delete($event)" (onClick2)="edit($event)"
                (onChangePage)="onChangePage($event)" (onSort)="onSort($event)">
            </frg-table>
        </div>
    </div>
</div>